<template>
  <div class="chart-container">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default {
  name: 'Barchart',
  components: { Bar },
  props: {
    dailySales: {
      type: Array,
      required: true
    },
    height: {
      type: [Number, String],
      default: 150 // Default height for compact layout
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.dailySales.map(item => item.date),
        datasets: [
          {
            label: 'Total Sales (USD)', // Still needed for tooltips
            data: this.dailySales.map(item => item.total),
            backgroundColor: '#42A5F5',
            borderColor: '#1E88E5',
            borderWidth: 1
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Sales (USD)',
              font: {
                size: 10 // Reduce font size of y-axis title
              }
            },
            ticks: {
              font: {
                size: 8 // Reduce font size of y-axis ticks
              }
            }
          },
          x: {
            title: {
              display: true,
              text: 'Date',
              font: {
                size: 10 // Reduce font size of x-axis title
              }
            },
            ticks: {
              font: {
                size: 8 // Reduce font size of x-axis ticks
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false // Remove the legend ("Total Sales (USD)")
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const label = context.dataset.label || '';
                const value = context.raw || 0;
                return `${label}: $${value.toFixed(2)}`;
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: v-bind(height + 'px'); /* Use the height prop dynamically */
  width: 100%;
}
</style>